import Vue from "vue";
import Router from "vue-router";
import PageNotFound from "./views/PageNotFound.vue";
import store from "./store.js";
Vue.use(Router);

const router = new Router({
    base: process.env.BASE_URL,
    routes: [
        // {
        // path: "/",
        // name: "Default",
        // redirect: { name: "order-list" },
        // },
        {
            path: "/",
            name: "Default",
            redirect: {
                name: "Home"
            }
        },
        {
            path: "/home",
            name: "Home",
            component: () => import( /* webpackChunkName: "Home" */
                "./views/Home.vue")
        },
        {
            path: "/setting",
            name: "Setting",
            component: () => import( /* webpackChunkName: "Setting" */
                "./views/Setting.vue")
        },
        {
            path: "/order/manage",
            name: "manage-order",
            component: () => import( /* webpackChunkName: "manageOrder" */
                "./views/ManageOrder.vue")
        }, {
            path: "/order/manageMultiple",
            name: "manage-order-multiple",
            component: () => import( /* webpackChunkName: "manageOrderMultiple" */
                "./views/ManageOrderMultiple.vue")
        }, {
            path: "/order/list",
            name: "order-list",
            component: () => import( /* webpackChunkName: "orderList" */
                "./views/OrderList.vue")
        },{
            path: "/dailyriderlist",
            name: "dailyriderlist",
            component: () => import( /* webpackChunkName: "dailyriderlist" */
                "./views/DailyRiderList.vue")
        },{
            path: "/dailyriderpaylist",
            name: "dailyriderpaylist",
            component: () => import( /* webpackChunkName: "dailyriderpaylist" */
                "./views/DailyRiderPayList.vue")
        },{
            path: "/dailyrestaurantlist",
            name: "dailyrestaurantlist",
            component: () => import( /* webpackChunkName: "dailyrestaurantlist" */
                "./views/DailyRestaurantList.vue")
        },
         {
            path: "/completeReport",
            name: "complete-report",
            component: () => import( /* webpackChunkName: "completeReport" */
                "./views/CompleteReport.vue")
        }, {
            path: "/townshipandcity",
            name: "township-city",
            component: () => import( /* webpackChunkName: "townshipAndCity" */
                "./views/TownshipAndCity.vue")
        }, {
            path: "/bank",
            name: "bank",
            component: () => import( /* webpackChunkName: "bank" */
                "./views/Bank.vue")
        }, {
            path: "/voucherPrint",
            name: "voucherPrint",
            component: () => import( /* webpackChunkName: "voucherPrint" */
                "./views/VoucherPrint.vue")
        }, {
            path: "/branch",
            name: "branch",
            component: () => import( /* webpackChunkName: "branch" */
                "./views/Branch.vue")
        }, {
            path: "/onlineshopping",
            name: "onlineshopping",
            component: () => import( /* webpackChunkName: "onlineShopping" */
                "./views/OnlineShopping.vue")
        }, {
            path: "/account",
            name: "account",
            component: () => import( /* webpackChunkName: "account" */
                "./views/AccountUser.vue")
        }, {
            path: "/expense",
            name: "expense",
            component: () => import( /* webpackChunkName: "expense" */
                "./views/Expense.vue")
        }, {
            path: "/income",
            name: "income",
            component: () => import( /* webpackChunkName: "income" */
                "./views/Income.vue")
        }, {
            path: "/finance",
            name: "finance",
            component: () => import( /* webpackChunkName: "finance" */
                "./views/Finance.vue")
        }, {
            path: "/order/list/process",
            name: "delivery-report",
            component: () => import( /* webpackChunkName: "deliveryReport" */
                "./views/ProcessList.vue")
        },{
            path: "/order/os",
            name: "order-os",
            component: () => import( /* webpackChunkName: "orderos" */
                "./views/OrderOs.vue")
        }, {
            path: "/barcode/scan",
            name: "barcode-scan",
            component: () => import( /* webpackChunkName: "barcodeScan" */
                "./views/BarCodeReader.vue")
        }, {
            path: "/barcode/generate",
            name: "barcode-generate",
            component: () => import( /* webpackChunkName: "barcodeGenerate" */
                "./views/BarcodeGenerate.vue")
        }, {
            path: "/saleReport",
            name: "sale-report",
            component: () => import( /* webpackChunkName: "saleReport" */
                "./views/SaleReport.vue")
        }, {
            path: "/advanceReport",
            name: "advance-report",
            component: () => import( /* webpackChunkName: "advanceReport" */
                "./views/AdvanceReport.vue")
        }, {
            path: "/incomeReport",
            name: "incomeReport",
            component: () => import( /* webpackChunkName: "incomeReport" */
                "./views/IncomeReport.vue")
        }, {
            path: "/payment",
            name: "payment",
            component: () => import( /* webpackChunkName: "payment" */
                "./views/Payment.vue")
        }, {
            path: "/expenseReport",
            name: "expenseReport",
            component: () => import( /* webpackChunkName: "expenseReport" */
                "./views/ExpenseReport.vue")
        }, {
            path: "/profitAndLoss",
            name: "profitAndLoss",
            component: () => import( /* webpackChunkName: "profitAndLoss" */
                "./views/ProfitAndLoss.vue")
        },{
            path: "/riderTime",
            name: "riderTime",
            component: () => import( /* webpackChunkName: "riderTime" */
                "./views/RiderTimeReport.vue")
        },{
            path: "/riderAnalyze",
            name: "riderAnalyze",
            component: () => import( /* webpackChunkName: "riderAnalyze" */
                "./views/RiderAnalyzeReport.vue")
        },{
            path: "/restAnalyze",
            name: "restAnalyze",
            component: () => import( /* webpackChunkName: "restAnalyze" */
                "./views/RestaurantAnalyzeReport.vue")
        }, {
            path: "/debtorAndcreditor",
            name: "debtorAndcreditor",
            component: () => import( /* webpackChunkName: "debtorAndcreditor" */
                "./views/DebtorAndCreditorReport.vue")
        }, {
            path: "/onlineDetailStatement",
            name: "onlineDetailStatement",
            component: () => import( /* webpackChunkName: "onlineDetailStatementReport" */
                "./views/OnlineDetailStatementReport.vue")
        }, {
            path: "/deliveryStatement",
            name: "deliveryStatement",
            component: () => import( /* webpackChunkName: "deliveryStatement" */
                "./views/DeliveryStatement.vue")
        }, {
            path: "/companyProfile",
            name: "companyProfile",
            component: () => import( /* webpackChunkName: "CompanyProfile" */
                "./views/CompanyProfile.vue")
        }, {
            path: "/rating",
            name: "rating",
            component: () => import( /* webpackChunkName: "rating" */
                "./views/Rating.vue")
        },{
            path: "/map",
            name: "map",
            component: () => import( /* webpackChunkName: "Map" */
                "./views/Map.vue")
        }, {
            path: "/customer",
            name: "customer",
            component: () => import( /* webpackChunkName: "Customer" */
                "./views/Customer.vue")
        }, {
            path: "/task",
            name: "task",
            component: () => import( /* webpackChunkName: "Task" */
                "./views/Task.vue")
        }, {
            path: "/daily",
            name: "daily",
            component: () => import( /* webpackChunkName: "daily" */
                "./views/DailyList.vue")
        },{
            path: "/osnoti",
            name: "osnoti",
            component: () => import( /* webpackChunkName: "OsNoti" */
                "./views/OsNoti.vue")
        },{
            path: "/trackingStatus",
            name: "trackingStatus",
            component: () => import( /* webpackChunkName: "TrackingStatus" */
                "./views/TrackingStatus.vue"),
            meta: {
                public: true
            }
        }, {
            path: "/login",
            name: "login",
            component: () => import( /* webpackChunkName: "login" */
                "./views/Login.vue"),
            meta: {
                public: true, // Allow access to even if not logged in
                onlyWhenLoggedOut: true
            }
        }, {
            path: "/report",
            name: "report",
            component: () => import( /* webpackChunkName: "report" */
                "./views/Report.vue")
        },
        {
            path: "/statement",
            name: "statement",
            component: () => import( /* webpackChunkName: "statement" */
                "./views/Statement.vue")
        },
        {
            path: "/incomeexpense",
            name: "incomeexpense",
            component: () => import( /* webpackChunkName: "incomeexpense" */
                "./views/IncomeExpense.vue")
        },
        {
            path: "/settings",
            name: "settings",
            component: () => import( /* webpackChunkName: "settings" */
                "./views/Settings.vue")
        },
        {
            path: "/dailypercent",
            name: "dailypercent",
            component: () => import( /* webpackChunkName: "dailypercent" */
                "./views/DailyPercent.vue")
        },
        {
            path: "/ui",
            name: "ui",
            component: () => import( /* webpackChunkName: "uiui" */
                "./views/UiAccept.vue")
        },
        {
            path: "*",
            component: PageNotFound
        },
    ],
    scrollBehavior(to, from, savedPosition) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                if (savedPosition) {
                    resolve(savedPosition);
                } else {
                    resolve({ x: 0, y: 0 });
                }
            }, 500);
        });
    }
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => !record.meta.public)) {
        let accessToken = store.state.userAccount.password;
        const loggedIn = accessToken != undefined && accessToken != "";
        if (loggedIn) {
            next();
            return
        }
        next({ name: "login" })
    }
    next()


    // if (to.name !== 'Login' && to.matched.some((record) => record.meta.requiresAuth)) {

    // if (loggedIn) {

    //     next();
    //     //return;
    // }else{
    //     next({
    //       name: "login"
    //     })
    // }

    // } else {
    // console.log("Else Next")
    // next();
    // }
    // console.log("object");
    // const isPublic = to.matched.some(record => record.meta.public);
    // const onlyWhenLoggedOut = to.matched.some(
    // record => record.meta.onlyWhenLoggedOut
    // );

    // let accessToken = store.state.userAccount.password;
    // const loggedIn = (accessToken != undefined && accessToken != "");
    // console.log(isPublic);
    // console.log(loggedIn);
    // console.log(to.fullPath);
    // console.log("object k condition");
    // console.log(!isPublic && !loggedIn);
    // console.log(loggedIn && onlyWhenLoggedOut);
    // console.log("object k condition end");
    // if (!isPublic && !loggedIn) {
    //     console.log("object x");
    //     return replace("/login")
    // }
    // //   return next({
    // //     path: "/login",
    // //     query: {
    // //       redirect: to.fullPath
    // //     }
    // //     // Store the full path to redirect the user to after login
    // //   });
    // // }
    // // }
    // if (loggedIn && onlyWhenLoggedOut) {
    // // Do not allow user to visit login page or register page if they are logged in
    // console.log("object 1");
    // return next("/");
    // }

    // next();
});
export default router;
